import React, { createContext, useContext } from 'react'
import useDashboardFilter, {
  UseDashboardFilterReturn
} from 'src/hooks/useDashboardFilter'

const DashboardFilterContext = createContext<UseDashboardFilterReturn | null>(
  null
)

export function DashboardFilterProvider({
  children
}: {
  children: React.ReactNode
}) {
  const filter = useDashboardFilter()

  return (
    <DashboardFilterContext.Provider value={filter}>
      {children}
    </DashboardFilterContext.Provider>
  )
}

export function useDashboardFilterContext(): UseDashboardFilterReturn {
  const ctx = useContext(DashboardFilterContext)
  if (!ctx) {
    throw new Error(
      'useDashboardFilterContext must be used within DashboardFilterProvider'
    )
  }
  return ctx
}

/**
 * Same context, but returns `null` instead of throwing when no provider is
 * mounted. Use from components rendered both inside the dashboard (where the
 * filter is meaningful) and outside (LandingNav, ProfileButton on public
 * pages) — let the consumer decide what to do when the context isn't there.
 */
export function useDashboardFilterContextOptional(): UseDashboardFilterReturn | null {
  return useContext(DashboardFilterContext)
}
